

























import { Vue, Component, PropSync } from 'vue-property-decorator';
@Component
export default class SubjectForm3 extends Vue {
  @PropSync('syncMode') _syncMode!: number;

  changeMode(mode: number) {
    this._syncMode = mode;
  }
  
}
